export default "__VITE_ASSET__BSdDM0fg__"